import React from 'react';

import { Grid } from '@mui/material';
import ValidatedDropdown, { DropdownOption } from 'components/Common/ValidatedDropdown';
import { OTHER_REASONS, REASONS_TYPE } from 'views/PartnerTabs/RejectWithdrawDialog/constant';
import { PartnerStatus } from 'types/Partner';
import ValidatedTextField from 'components/Common/ValidatedTextField';
import { useFormikContext } from 'formik';
import { RejectWithdrawFormType } from 'views/PartnerTabs/RejectWithdrawDialog/RejectWithdrawDialog';

export type ReasonFieldsType = {
  modalType: PartnerStatus.WITHDRAWN | PartnerStatus.REJECTED;
};

const ReasonFields = ({ modalType }: ReasonFieldsType) => {
  const { values, setFieldValue, setFieldTouched, isSubmitting, validateForm } =
    useFormikContext<RejectWithdrawFormType>();

  return (
    <>
      <Grid item xs={12}>
        <ValidatedDropdown
          isDisabled={isSubmitting}
          options={REASONS_TYPE[(modalType as PartnerStatus.WITHDRAWN) || PartnerStatus.REJECTED]}
          label="Reason"
          name="rejectWithdrawReason"
          action={(value: DropdownOption) => {
            const selectedReason = value?.value ?? null;
            setFieldValue('rejectWithdrawReason', selectedReason);
            setFieldTouched('rejectWithdrawReason', true, false);
            if (selectedReason !== OTHER_REASONS) {
              setFieldValue('rejectWithdrawReasonOthers', '');
            }
            setTimeout(() => {
              validateForm();
            });
          }}
        />
      </Grid>
      {values.rejectWithdrawReason === OTHER_REASONS && (
        <Grid item xs={12}>
          <ValidatedTextField disabled={isSubmitting} label="Other" name="rejectWithdrawReasonOthers" maxChar={250} />
        </Grid>
      )}
    </>
  );
};

export default ReasonFields;
